// extracted by mini-css-extract-plugin
export default {"cancel-btn":"styles_cancel-btn__tCABa"};